import { useLocation } from 'react-router';

const HIDDEN_NOTIFICATION_PATHS = ['/cart/checkout', '/cart/guest_checkout'];

export const useHideNotifications = () => {
  const { pathname } = useLocation();

  return HIDDEN_NOTIFICATION_PATHS.some((path) => pathname.includes(path));
};
